import { styled } from '@mui/material';

const PREFIX = 'CurrencyAdjustedValueViewer';

export const classes = {
  chipContainer: `${PREFIX}-chipContainer`,
};

export const Root = styled('button')({
  [`& .${classes.chipContainer}`]: {
    display: 'inline-block',
    verticalAlign: 'middle',
    position: 'absolute',
    left: '0.5rem',
    top: '50%',
    transform: 'translateY(-50%)',
  },
});